import { ITrack } from '@/data/models/track';
import { useMultipleTrackEditView } from '@/hooks/useMultipleTrackEditView';
import React from 'react';
import { IMultipleTrackEdit } from '@/types/multiple-track-types';
import TrackEditViewTemplate from '@/components/partials/ProductTabs/TrackEditView/TrackEditViewTemplate';
import { IChangeRequest } from '@/data/models/changeRequest';

interface Props {
  togglePopUp: any;
  trackObj: ITrack;
  reloadTracks: any;
  multipleTracksEdit?: IMultipleTrackEdit;
  usesSides?: boolean;
  readonly?: boolean;
  disabled?: boolean;
  catalogUpc?: string | null;
  onSaveSuccess?: () => void;
  changeRequest?: IChangeRequest;
}

const MultipleTrackEdit = (props: Props) => {
  const hookData = useMultipleTrackEditView({
    togglePopUp: props.togglePopUp,
    albumObj: props.multipleTracksEdit!.album,
    trackObj: props.trackObj,
    reloadTracks: props.reloadTracks,
    multipleTracks: props.multipleTracksEdit!.trackList,
    onSaveSuccess: props.onSaveSuccess,
    changeRequest: props.changeRequest,
  });

  return (
    <TrackEditViewTemplate
      readonly={props.readonly}
      disabled={props.disabled}
      usesSides={props.usesSides}
      multipleTracksEdit={props.multipleTracksEdit}
      isMultipleTrack={true}
      areNewMultipleTracks={props.multipleTracksEdit!.areNewTracks}
      multipleTracksCount={props.multipleTracksEdit!.trackList.length}
      formatName={props.multipleTracksEdit?.album.format?.name}
      trackData={hookData.track}
      baseMixedTrack={hookData.baseMixedTrack}
      showPopUp={hookData.showPopUp}
      onCancel={hookData.onCancel}
      closePopUp={hookData.closePopUp}
      isSubmitting={hookData.isSubmitting}
      showCancelChangesModal={hookData.showCancelChangesModal}
      setShowCancelChangesModal={hookData.setShowCancelChangesModal}
      handleSubmit={hookData.handleSubmit}
      saveErrorMessage={hookData.saveErrorMessage}
      onSaveErrorClose={() => hookData.setSaveErrorMessage(null)}
      handleInput={hookData.handleInput}
      handleArtist={hookData.handleArtist}
      handleWriterComposer={hookData.handleWriterComposer}
      handlePublisher={hookData.handlePublisher}
      isTrackValid={true}
      fieldHasErrors={() => false}
      findErrorMessage={() => ''}
      albumState={props.multipleTracksEdit?.album.albumState}
    />
  );
};

export default MultipleTrackEdit;
